import { STATES } from 'common/domain/states';
import { PAGE_ERROR } from 'common/domain/constants';

class SolidarityRoutingController {

  constructor($scope, solidarityService , $state) {
    'ngInject';
    this.scope = $scope;
    this.solidarityService = solidarityService;
    this.state = $state;
  }

  $onInit() {
    this.isModuleClosed();
    this.solidarityService.loadData();
  }

  isModuleClosed() {
    if(this.moduleClosed.isSolidarityEuroClosed && this.moduleClosed.solidarityEuroClosedMessage) {
      this.state.go(STATES.ERROR, {stateName: PAGE_ERROR.CLOSED , errorMessage: this.moduleClosed.solidarityEuroClosedMessage });
      return true;
    }else if(this.moduleClosed.isSolidarityEuroClosed){
      this.state.go(STATES.ERROR, {stateName: PAGE_ERROR.CLOSED });
      return true; 
    }
    
    return false;
  }

}

export default SolidarityRoutingController;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/solidarityRouting/solidarityRouting.controller.js